import React, { useEffect } from 'react';
import { IoIosClose } from 'react-icons/io';

interface Iprops {
  file: any;
  onClick: () => void;
  hideCross?: any;
  label?: string;
}

const PreviewImage: React.FC<Iprops> = ({
  file,
  onClick,
  label,
  hideCross = false,
}) => {
  return (
    <>
      <label className="text-text-black font-normal text-md mb-2 block">
        {label}
      </label>
      <div className="d-flex align-items-center justify-content-center relative bg-[#fff] shadow-[2.5px_2.5px_12px_#ffffff,2.5px_2.5px_12px_#e3e3e3] rounded-xl p-4">
        <img
          src={file}
          alt="preview"
          className="w-full h-56 object-contain mx-auto"
        />
        {!hideCross && (
          <IoIosClose
            className="absolute -top-2 -right-2 bg-primary rounded-full "
            size={20}
            color="#FFFFFF"
            onClick={onClick}
          />
        )}
      </div>
    </>
  );
};

export default PreviewImage;
